import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, throwError, take, Observable, map, catchError, of, tap } from 'rxjs';
import { ToastService } from './toast.service';
import { ShareddtaService } from './shareddta.service';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  apiUrl = environment.apiUrl;
  port = environment.port;
  _liveApiUrls: string = '';
  private retrievedDataSubject = new BehaviorSubject<string>('');
  retrievedData$ = this.retrievedDataSubject.asObservable();
  _apiUrl = new BehaviorSubject<any>(this.apiUrl);
  _isDashboard = new BehaviorSubject<any>(false);
  _isRole = new BehaviorSubject<any>('0');
  _fcm_token = new BehaviorSubject<any>('0');

  _profile = new BehaviorSubject<any>(false);
  _adminListing = new BehaviorSubject<any>(false);
  private actionSubject = new Subject<void>();
  action$ = this.actionSubject.asObservable();
  private ticketactionSubject = new Subject<void>();
  ticketaction$ = this.ticketactionSubject.asObservable();
  private driveractionSubject = new Subject<void>();
  driveraction$ = this.driveractionSubject.asObservable();
  private orderactionSubject = new Subject<void>();
  orderaction$ = this.orderactionSubject.asObservable();
  private locatedriveractionSubject = new Subject<void>();
  locatedriveraction$ = this.locatedriveractionSubject.asObservable();
  private sendnotificationactionSubject = new Subject<void>();
  sendnotificationraction$ = this.sendnotificationactionSubject.asObservable();
  private dataSubject = new Subject<any>();
  currentData$ = this.dataSubject.asObservable();
  private sadataSubject = new Subject<any>();
  sacurrentData$ = this.sadataSubject.asObservable();
  private liveApiUrlSource = new BehaviorSubject<string>('');
  liveApiUrl$ = this.liveApiUrlSource.asObservable();
  _liveApiUrl = this.apiUrl;
  _isLoggedIn: any = false;
  _isRoleIn: any = false;
  _isRoleName: any = '0';
  isLoggingOut: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService, private toast: ToastService, private shareddta: ShareddtaService
  ) {
    this.getApiUrl.subscribe((data: any) => {
      this._liveApiUrl = data;
      this.liveApiUrlSource.next(data);
      console.log(this._liveApiUrl, ' this._liveApiUrl')
    });

    this.getDashboard().subscribe((data: any) => {
      this._isLoggedIn = data;
    });

    this.getRole().subscribe((data: any) => {
      if (data != false) {
        this._isRoleIn = data[0];
        const isShippedAdmin = localStorage.getItem('is_shipped_admin') === 'true';
        const isReceivingAdmin = localStorage.getItem('is_receiving_admin') === 'true';

        if (data[0] == 1) {
          this._isRoleName = 'superadmin';
        } else if (data[0] == 2) {
          if (isShippedAdmin) {
            this._isRoleName = 'admin';
          } else if (isReceivingAdmin) {
            this._isRoleName = 'receiving-admin';
          } else {
            this._isRoleName = 'admin';
          }
        } else if (data[0] == 3) {
          this._isRoleName = 'receiving-admin';
        }
      } else {
        this._isRoleIn = data;
      }
    });
  }
  triggerAction() {
    this.actionSubject.next();
  }
  ticketAction() {
    this.ticketactionSubject.next();
  }
  driverAction() {
    this.driveractionSubject.next();
  }
  orderAction() {
    this.orderactionSubject.next();
  }
  locatedriverAction() {
    this.locatedriveractionSubject.next();
  }
  sendnotificationAction() {
    this.sendnotificationactionSubject.next();
  }
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      msg = error.error.message;
    } else {
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // Return original error so specialized handlers (dataError) can see the status
    return throwError(() => error);
  }
  setRetrievedData(data: string) {
    this.retrievedDataSubject.next(data);
  }
  sendDataToAuthService(data: string): void {
    this._liveApiUrls = data;
    console.log('Received data in AuthService:', data);
  }
  dataError(error: any) {
    if (!navigator.onLine || error.status === 0 || error.status === 500) {
        // Suppress generic error toast as specialized handlers take over
        console.warn('API Error:', error);
        return;
    }
    this.toast.show('error', 'Something went wrong. Please try again later.');
    console.error('API Error:', error);
  }

  // resultCodeError(data: any) {
  //   if(data?.resultCode == 4) {
  //     // this.toastr.error(data?.errorMessage);

  //     // this.doLogout();
  //     this.tokenRefresh();

  //     return ;
  //   }else 
  //   if (
  //     data?.resultCode == '0' ||
  //     data?.resultCode == 0
  //   ) {
  //     this.toastr.error(data?.errorMessage);
  //     this.doLogout();
  //     return true;
  //   } else {
  //     return false;
  //   }
  resultCodeError(data: any) {
    if (data?.resultCode == 4) {
      if (this.isLoggingOut) return true;
      this.toast.show('error', 'Your session has expired. Please login again.');
      this.doLogout();
      return true;
    } else if (
      data?.resultCode == '0' ||
      data?.resultCode == 0
    ) {
      if (this.isLoggingOut) return true;
      const errorMsg = data?.errorMessage || data?.message || data?.actionPerformed || data?.resultDescription;
      if (errorMsg) {
        this.toast.show('error', errorMsg);
      }
      // this.doLogout();
      return true;
    } else {
      return false;
    }
  }

  reloadComponent() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });

    if (currentUrl === '/admin/dashboard') {
      const dataToSend = { reload: true };

      // Send data before reloading the component
      this.sendData(dataToSend);
    }
    if (currentUrl === '/superadmin/dashboard') {
      const dataToSend = { reload: true };

      // Send data before reloading the component
      this.sendData1(dataToSend);
    }
  }

  sendData(data: any) {
    this.dataSubject.next(data);
    console.log('Data sent:', data); // Console statement
  }
  sendData1(data: any) {
    this.sadataSubject.next(data);
    console.log('Data sent:', data); // Console statement
  }

  get getToken() {
    return this.getLS('access_token');
  }

  get getOrgEmail() {
    return this.getLS('org_email');
  }

  get getOrgDomain() {
    return this.getLS('org_domain');
  }

  get isOrgIn(): boolean {
    let orgEmail = this.getLS('org_email');
    return orgEmail !== null ? true : false;
  }

  getProfile(): Observable<any[]> {
    this.getUserProfile();
    return this._profile.asObservable();
  }
  getAdmin(): Observable<any[]> {
    this.getAdminListing();
    return this._adminListing.asObservable();
  }

  getDashboard(): Observable<any[]> {
    let authToken = this.getLS('access_token');
    this._isDashboard.next(authToken !== null ? true : false);
    return this._isDashboard.asObservable();
  }

  getRole(): Observable<any[]> {
    let role = this.getLS('role');
    this._isRole.next(role !== null ? role : '0');
    return this._isRole.asObservable();
  }
  getfcm_token() {
    let token = this.getLS('fcm_token');
    this._fcm_token.next(token !== null ? token : '0');
    return token;
  }

  get getApiUrl(): Observable<any[]> {
    let orgDomain = this.getLS('org_domain');
    this._apiUrl.next(
      orgDomain !== null ? orgDomain + ':' + this.port : this.apiUrl
    );
    return this._apiUrl.asObservable();
  }

  setLS(k: any, v: any) {
    return localStorage.setItem(k, v);
  }

  getLS(k: any) {
    return localStorage.getItem(k);
  }

  rmLS(k: any) {
    return localStorage.removeItem(k);
  }

  doLogout() {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;
    this.rmLS('refresh_token');
    this.rmLS('name');
    this.rmLS('role');
    this.rmLS('user_timezone');
    this.rmLS('org_email');
    this.rmLS('org_name');
    this.rmLS('org_Id');
    this.rmLS('schema_name');
    this.rmLS('compname');
    this.rmLS('org_phone');
    this.rmLS('org_domain');
    this.rmLS('role');
    this.rmLS('is_first_login');
    this.rmLS('addcompany');
    this.rmLS('notifId');
    this.rmLS('first_city_enter');
    this.rmLS('ng2Idle.main.idling');
    this.rmLS('ng2Idle.main.expiry');
    this.rmLS('ArkiverActive');
    // Preserve remembered emails, clear everything else
    const preserved = ['remembered_emails'];
    Object.keys(localStorage).forEach(key => {
      if (!preserved.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    localStorage.setItem('isLoggedIn', 'false');
    // sessionStorage.clear();
    let removeToken = this.rmLS('access_token');
    sessionStorage.removeItem('ticket_selected_tab');
    sessionStorage.removeItem('admin_ticket_selected_tabs');
    this._isDashboard.next(false);
    this._isRole.next('0');
    this._profile.next(false);
    
    // Force hard reload to login page to wipe SPA memory completely
    this.router.navigate(['/']).then(() => {
        window.location.reload();
    });
  }

  getUserProfile() {
    this.http
      .get<any>(`${this._liveApiUrl}/account/user-profile/`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      )
      .subscribe(
        (data: any) => {
          if (this.resultCodeError(data)) {
            return;
          }
          if (data?.result?.admin?.country_code) {
            this.shareddta.updateCountryCode(data.result.admin.country_code);
          }
          this._profile.next(data);
        },
        (error) => {
          this.dataError(error);
        }
      );
  }
  getAdminListing() {
    this.http
      .get<any>(`${this._liveApiUrl}/account/admin-listing/?page_size=100`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      )
      .subscribe(
        (data: any) => {
          if (this.resultCodeError(data)) {
            return;
          }
          this._adminListing.next(data);
        },
        (error) => {
          this.dataError(error);
        }
      );
  }
  deleteAdmin(id: any) {

    return this.http.delete<any>(`${this._liveApiUrl}/account/user-profile/?admin_id=${id}`).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError)
    );

  }
  editAdmin(id: Number, form: any) {
    return this.http
      .put<any>(`${this._liveApiUrl}/account/update-profile/${id}`, form)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }
  activateDeactivateAdmin(id: number, status: boolean) {
    const formData = new FormData();
    formData.append('admin_status', status ? 'true' : 'false');
    return this.http
      .put<any>(`${this._liveApiUrl}/account/activate-deactivate-admin/${id}`, formData)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }
  cancelSubs(id: number) {
    return this.http
      .put<any>(`${this._liveApiUrl}/tenant/organization-cancel-plan/${id}`, {})
      .pipe(
        catchError(this.handleError)
      );
  }

  mobileData: any;
  getOrganization(email: string, role?: string) {
    this.isLoggingOut = false;
    return this.http
      .post<any>(`${environment.apiUrl}/tenant/get-organization/`, {
        email,
        role
      })
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }

  login(email: string, password: string, token: any, device_type: string) {
    this.isLoggingOut = false;
    let fcm_token: any = token ? token : '123'
    const user_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.http
      .post<any>(`${this._liveApiUrl}/account/token/`, {
        email,
        password,
        fcm_token,
        device_type,
        user_timezone
      })
      .pipe(
        map((data) => {
          if (data?.access_token != undefined) {
            if ((data.first_city_enter && data.is_first_login) == true) {
              return data;
            }
            else {
              this._isDashboard.next(data?.access_token);
              this._isRole.next(data?.role);
            }

          }
          return data;
        }),
        catchError(this.handleError)
      );
  }
  mobileNumber: any;
  setMobileNumber(mobileNumber: string) {
    this.mobileNumber = mobileNumber;
  }
  email: any
  setEmail(email: string) {
    this.email = email;
  }

  getMobileNumber() {
    return this.mobileNumber;
  }
  getEmail() {
    return this.email;
  }
  countryCodes: any;
  setCountryCode(countryCode: string) {
    this.countryCodes = countryCode;
  }

  getCountryCode() {
    return this.countryCodes;
  }
  // sendMobileOtp(mobile_no: string, country_code?: string) {
  //   return this.http
  //     .post<any>(`${this._liveApiUrl}/account/send-mobile-otp/`, {
  //       mobile_no,
  //       country_code,
  //       is_registration:'true'
  //     })
  //     .pipe(
  //       map((data) => {
  //         return data;
  //       }),
  //       catchError(this.handleError)
  //     );
  // }
  sendMobileOtp(mobile_no: string, country_code?: string, isRegistration: boolean = false) {

    // base body
    const body: any = {
      mobile_no,
      country_code
    };

    // sirf tab add hoga jab isRegistration TRUE ho
    if (isRegistration) {
      body.is_registration = 'true';
    }

    return this.http
      .post<any>(`${this._liveApiUrl}/account/send-mobile-otp/`, body)
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }
  sendEmailOtp(email: string, isRegistration: boolean = false) {

    // base body
    const body: any = {
      email,
      isRegistration
    };

    // sirf tab add hoga jab isRegistration TRUE ho
    if (isRegistration) {
      body.is_registration = 'true';
    }

    return this.http
      .post<any>(`${this._liveApiUrl}/account/send-email-otp/`, body)
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }
  verifyOtp(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/account/verify-otp/`, payload)
      .pipe(map((data: any) => data));
  }
  profileUpdate(id: any, form: any) {
    return this.http
      .put<any>(`${this._liveApiUrl}/account/update-profile/${id}`, form)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }

  updateUserCountryCode(code: string): Observable<any> {
    const profile = this._profile.getValue();
    if (!profile || !profile.result || !profile.result.admin) {
      return of(null);
    }
    const id = profile.result.admin.id;
    const formData = new FormData();
    formData.append('country_code', code);
    // Keep other fields if necessary, but typically profile update accepts partial
    formData.append('first_name', profile.result.admin.first_name);
    formData.append('last_name', profile.result.admin.last_name);
    formData.append('email', profile.result.admin.email);
    formData.append('phone_number', profile.result.admin.phone_number || '');

    return this.http.put<any>(`${this._liveApiUrl}/account/update-profile/${id}`, formData).pipe(
      tap(res => {
        if (res.resultCode == 1) {
          this.shareddta.updateCountryCode(code);
        }
      }),
      catchError(this.handleError)
    );
  }


  addSuperAdmin(form: any) {
    return this.http
      .post<any>(`${this._liveApiUrl}/account/user-profile/`, form)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }
  loginByOtp(email: string, password: string, login_by: string = 'otp') {
    return this.http
      .post<any>(`${this._liveApiUrl}/account/token/`, {
        email,
        password,
        login_by,
      })
      .pipe(
        map((data) => {
          if (data?.access_token != undefined) {
            this._isDashboard.next(data?.access_token);
            this._isRole.next(data?.role);
          }
          return data;
        }),
        catchError(this.handleError)
      );
  }

  sendResetOtp(email: string, country_code?: any) {
    // Prepare the payload
    const payload: any = { email };

    // Add country_code to the payload only if it is provided
    if (country_code) {
      payload.country_code = country_code;
    }

    return this.http
      .post<any>(`${this._liveApiUrl}/account/send-reset-otp/`, payload)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }


  verifyResetOtp(email: string, otp: string, country_code?: any) {
    return this.http
      .post<any>(`${this._liveApiUrl}/account/verify-reset-otp/`, {
        email,
        otp,
        country_code
      })
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }

  resetPassword(email: string, new_password: string) {
    return this.http
      .put<any>(`${this._liveApiUrl}/account/reset-password/`, {
        email,
        new_password,
      })
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }
  resetPasswords(email: string, new_password: string) {
    return this.http
      .put<any>(`${this._liveApiUrls}/account/reset-password/`, {
        email,
        new_password,
      })
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }
  addCity(admin_email: string, city_status: string, city: string) {
    return this.http
      .put<any>(`${this._liveApiUrls}/tenant/organization-city-change/`, {
        admin_email,
        city_status,
        city
      })
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }
  // tokenRefresh() {
  //   const refresh = this.getLS('refresh_token');
  //   if (!refresh) {
  //     return;
  //   }
  //   return this.http
  //     .post<any>(`${this._liveApiUrl}/account/token/refresh/`, {
  //       refresh,
  //     })
  //     .pipe(
  //       map((data) => {
  //         this.setLS('access_token', data?.access_token);  
  //         this.reloadComponent()
  //         // this.setLS('user', JSON.stringify(data));
  //         return data;
  //       }),
  //       catchError(this.handleError)
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         if (this.resultCodeError(data)) {
  //           return;
  //         }

  //       },
  //       (error) => {
  //         this.dataError(error);
  //       }
  //     );

  // }




  clearRouter() {
    this.router.navigate(['/' + this._isRoleName + '/dashboard'], {
      relativeTo: this.route,
      queryParams: {
        plan: null,
        search_text: null,
        bookmarked: null,
        deactivated: null,
        start_date: null,
        end_date: null,
      },
      queryParamsHandling: 'merge', //preserve
    });
  }

  setRouter(object: any) {
    this.clearRouter();
    this.router.navigate(['/' + this._isRoleName + '/dashboard'], {
      relativeTo: this.route,
      queryParams: object,
      queryParamsHandling: 'merge', //merge
    });
  }

  convertImageIntoBinary(imageSrc: any) {
    return this.http.get(imageSrc, { responseType: 'arraybuffer' });
  }
  async getFileFromUrl(url: any) {
    const response = await fetch(url);
    let randomNum = Math.floor((Math.random() * 10000000) + 1);
    const data = await response.blob();
    return new File([data], "sa_profile_" + randomNum, {
      type: "image/jpeg",
    });
  }
  private loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  show() {
    this.loading.next(true);
  }

  hide() {
    this.loading.next(false);
  }
  private roleChangedSource = new BehaviorSubject<string>('');

  // 🔁 Observable for components to subscribe
  roleChanged$: Observable<string> = this.roleChangedSource.asObservable();

  // 🔥 Called when role is changed
  broadcastRoleChange(role: string) {
    this.roleChangedSource.next(role);
  }
  notificationCount() {
    return this.http
      .get<any>(`${this._liveApiUrl}/notification/notification-count/`)
  }
  notificationShippingCount() {
    return this.http.get<any>(
      `${this._liveApiUrl}/notification/notification-count/`,
      { params: { is_shipped_admin: true } }
    );
  }
  notificationReciverCount() {
    return this.http.get<any>(
      `${this._liveApiUrl}/notification/notification-count/`,
      { params: { is_receiving_admin: true } }
    );
  }

  feeBackAdd(form: any) {
    return this.http
      .patch<any>(`${this._liveApiUrl}/company/send-mail/`, form)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(this.handleError)
      );
  }
}
